import { useI18n } from '../i18n/useI18n'
import { useAuth } from '../auth/useAuth'

/** Sommaire des ecrans qui ne meritent pas un onglet a eux. */
export function MoreScreen({ onNavigate }: { onNavigate: (to: string) => void }) {
  const { t } = useI18n()
  const { profile, signOut } = useAuth()

  const roleLabel = profile?.role
    ? t(`role_${profile.role}` as 'role_proprietaire' | 'role_gerant' | 'role_assistant')
    : ''

  return (
    <div className="screen">
      <h1 className="screen__title">{t('nav_more')}</h1>

      <ul className="list">
        <li>
          <button
            type="button"
            className="list__item list__item--tappable"
            onClick={() => onNavigate('/rapports')}
          >
            <span className="list__main">
              <span className="list__name">{t('reports_title')}</span>
              <span className="list__meta">{t('reports_intro')}</span>
            </span>
            <span className="list__side">→</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            className="list__item list__item--tappable"
            onClick={() => onNavigate('/documents')}
          >
            <span className="list__main">
              <span className="list__name">{t('documents_title')}</span>
            </span>
            <span className="list__side">→</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            className="list__item list__item--tappable"
            onClick={() => onNavigate('/locataires')}
          >
            <span className="list__main">
              <span className="list__name">{t('tenants_title')}</span>
            </span>
            <span className="list__side">→</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            className="list__item list__item--tappable"
            onClick={() => onNavigate('/immeuble')}
          >
            <span className="list__main">
              <span className="list__name">{t('units_title')}</span>
            </span>
            <span className="list__side">→</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            className="list__item list__item--tappable"
            onClick={() => onNavigate('/reglement')}
          >
            <span className="list__main">
              <span className="list__name">{t('settlement_title')}</span>
              <span className="list__meta">{t('settlement_intro')}</span>
            </span>
            <span className="list__side">→</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            className="list__item list__item--tappable"
            onClick={() => onNavigate('/charges')}
          >
            <span className="list__main">
              <span className="list__name">{t('recurring_title')}</span>
              <span className="list__meta">{t('recurring_intro')}</span>
            </span>
            <span className="list__side">→</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            className="list__item list__item--tappable"
            onClick={() => onNavigate('/banque')}
          >
            <span className="list__main">
              <span className="list__name">{t('bank_title')}</span>
              <span className="list__meta">{t('bank_intro')}</span>
            </span>
            <span className="list__side">→</span>
          </button>
        </li>
        <li>
          <button
            type="button"
            className="list__item list__item--tappable"
            onClick={() => onNavigate('/cautions')}
          >
            <span className="list__main">
              <span className="list__name">{t('deposits_title')}</span>
            </span>
            <span className="list__side">→</span>
          </button>
        </li>
      </ul>

      <div className="card">
        {/* Nom issu de la base, jamais traduit. */}
        <h2>{profile?.full_name ?? ''}</h2>
        <p className="muted">{roleLabel}</p>
        <button type="button" className="btn btn--ghost" onClick={() => void signOut()}>
          {t('logout')}
        </button>
      </div>
    </div>
  )
}
